import React, { BaseSyntheticEvent } from 'react'
import { smarty } from '@/src/modules/smarty/Smarty'

export interface IFullWidthFields {
    id: string
    value: string
    placeholder: string
    label: string
    setField: Function
    maxLength?: number
    autoComplete?: string
    type?: string
    maxWidth?: any
    format?: string
    className?: string
}

interface ISmartyAddressSuggestion {
    streetLine: string
    secondary: string
    city: string
    state: string
    zipcode: string
    entries: number
}

export interface ISmartyFunctions {
    setAddress1: Function
    setAddress2: Function
    setCity: Function
    setState: Function
    setZip: Function
}

export interface IHandleSelectFunctions {
    setAddressSuggestions: Function
    setAddressSearchValue: Function
    smartyFunctions: ISmartyFunctions
}

export const setSelectedAddress = (
    addressSuggestion: ISmartyAddressSuggestion,
    functions: {
        setAddress1: Function
        setAddress2: Function
        setCity: Function
        setState: Function
        setZip: Function
    }
) => {
    const { setAddress1, setAddress2, setCity, setZip, setState } = functions

    setAddress1(addressSuggestion.streetLine)
    setAddress2(addressSuggestion.secondary)
    setCity(addressSuggestion.city)
    setState(addressSuggestion.state)
    setZip(addressSuggestion.zipcode)
}
export const clearSelectedAddress = (functions: {
    setAddress1: Function
    setAddress2: Function
    setCity: Function
    setState: Function
    setZip: Function
}) => {
    const { setAddress1, setAddress2, setCity, setZip, setState } = functions

    setAddress1('')
    setAddress2('')
    setCity('')
    setState('')
    setZip('')
}
export const clearAddressSuggestions = (setAddressSuggestions: Function) => {
    setAddressSuggestions([])
}
export const clearAddressSearchValue = (setAddressSearchValue: Function) => {
    setAddressSearchValue('')
}

export const addressEntriesData = (
    addressSuggestion: ISmartyAddressSuggestion
) => {
    return addressSuggestion.entries > 1
        ? `${addressSuggestion.streetLine} ${addressSuggestion.secondary} (${addressSuggestion.entries}) ${addressSuggestion.city} ${addressSuggestion.state}, ${addressSuggestion.zipcode}`
        : null
}

export const formattedAddressInList = (
    addressSuggestion: ISmartyAddressSuggestion
) => {
    const entriesDisplay =
        addressSuggestion.entries > 1
            ? ` (${addressSuggestion.entries} more entries) `
            : ''

    return `${addressSuggestion.streetLine} ${addressSuggestion.secondary} ${entriesDisplay} ${addressSuggestion.city}, ${addressSuggestion.state}, ${addressSuggestion.zipcode}`
}

export const handleSuggestionSelect = async (
    e: BaseSyntheticEvent,
    addressSuggestion: ISmartyAddressSuggestion,
    addressSearchValue: string,
    handleSelectFunctions: IHandleSelectFunctions
) => {
    const { setAddressSearchValue, setAddressSuggestions, smartyFunctions } =
        handleSelectFunctions
    const addressEntriesRefinementData =
        e.target?.dataset?.addressEntriesRefinementData

    if (addressEntriesRefinementData) {
        const suggestions = await smarty(
            {
                street: addressSearchValue,
            },
            addressEntriesRefinementData
        )
        setAddressSuggestions(suggestions ?? [])
    } else {
        setSelectedAddress(addressSuggestion, smartyFunctions)
        clearAddressSearchValue(setAddressSearchValue)
        clearAddressSuggestions(setAddressSuggestions)
    }
}
